if (!customElements.get('pack-fijo')) {
  customElements.define(
    'pack-fijo',
    class PackFijo extends HTMLElement {
      connectedCallback() {
        this.units = parseInt(this.dataset.units, 10) || 0;
        this.filas = Array.from(this.querySelectorAll('.pb-flavor[data-variant]'));
        this.boton = this.querySelector('.pack-fijo__add');
        if (!this.units || !this.boton || !this.filas.length) return;

        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('change', this.onChange.bind(this));
        this.refresh();
      }

      input(fila) {
        return fila.querySelector('.pb-qty__input');
      }

      cantidad(fila) {
        return Math.max(0, parseInt(this.input(fila).value, 10) || 0);
      }

      get total() {
        return this.filas.reduce((suma, fila) => suma + this.cantidad(fila), 0);
      }

      get faltan() {
        return this.units - this.total;
      }

      onClick(event) {
        const paso = event.target.closest('.pb-qty__step');
        if (paso) {
          const fila = paso.closest('.pb-flavor');
          return this.fijar(fila, this.cantidad(fila) + parseInt(paso.dataset.step, 10));
        }

        if (event.target.closest('.pack-fijo__add')) this.agregar();
      }

      onChange(event) {
        if (!event.target.classList.contains('pb-qty__input')) return;
        const fila = event.target.closest('.pb-flavor');
        this.fijar(fila, this.cantidad(fila));
      }

      // Nunca mas que el total del pack entre todos los sabores.
      fijar(fila, valor) {
        const otros = this.total - this.cantidad(fila);
        this.input(fila).value = Math.max(0, Math.min(valor, this.units - otros));
        this.refresh();
      }

      refresh() {
        const total = this.total;
        const faltan = this.faltan;

        const contador = this.querySelector('[data-count]');
        if (contador) contador.textContent = total;

        this.filas.forEach((fila) => {
          const cantidad = this.cantidad(fila);
          const menos = fila.querySelector('[data-step="-1"]');
          const mas = fila.querySelector('[data-step="1"]');
          if (menos) menos.disabled = cantidad <= 0;
          if (mas) mas.disabled = total >= this.units;
        });

        this.classList.toggle('pack-fijo--completo', faltan === 0);
        this.boton.setAttribute('aria-disabled', String(faltan > 0));
        this.boton.querySelector('span').textContent =
          faltan > 0 ? this.dataset.remainingLabel.replace('[n]', faltan) : this.dataset.addLabel;

        if (faltan === 0) this.ocultarAviso();
      }

      mostrarAviso(texto) {
        const aviso = this.querySelector('.pack-options-notice');
        if (!aviso) return;
        aviso.querySelector('[data-notice]').textContent = texto;
        aviso.removeAttribute('hidden');
      }

      ocultarAviso() {
        this.querySelector('.pack-options-notice')?.setAttribute('hidden', '');
      }

      async agregar() {
        if (this.boton.classList.contains('loading')) return;

        if (this.faltan > 0) {
          this.mostrarAviso(this.dataset.remainingLabel.replace('[n]', this.faltan));
          return;
        }

        // Los sabores entran sueltos: el descuento automatico pone el precio.
        const items = this.filas
          .map((fila) => ({ id: Number(fila.dataset.variant), quantity: this.cantidad(fila) }))
          .filter((item) => item.quantity > 0);

        const drawer = document.querySelector('cart-drawer');
        this.boton.classList.add('loading');
        this.boton.querySelector('.loading__spinner')?.classList.remove('hidden');

        try {
          if (window.packTiers) {
            await window.packTiers.agregar(items);
          } else {
            const respuesta = await fetch(`${window.routes.cart_add_url}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
              body: JSON.stringify({
                items,
                sections: drawer ? drawer.getSectionsToRender().map((s) => s.id) : [],
                sections_url: window.location.pathname,
              }),
            });

            const resultado = await respuesta.json();
            if (resultado.status) throw new Error(resultado.description || resultado.message);

            if (drawer) drawer.renderContents(resultado);
            else window.location.href = window.routes.cart_url;
          }

          this.reset();
        } catch (e) {
          // Si Shopify agrego solo una parte, se limpia el pack para que otro
          // clic no duplique lo que ya entro, y el carrito se repinta sin abrirse.
          this.reset();
          await this.repintarCarrito();
          this.mostrarAviso(e.message);
        } finally {
          this.boton.classList.remove('loading');
          this.boton.querySelector('.loading__spinner')?.classList.add('hidden');
        }
      }

      async repintarCarrito() {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;

        try {
          const secciones = drawer.getSectionsToRender();
          const raiz = window.Shopify?.routes?.root || '/';
          const html = await fetch(`${raiz}?sections=${secciones.map((s) => s.id).join(',')}`).then((r) => r.json());

          secciones.forEach((seccion) => {
            const elemento = seccion.selector ? document.querySelector(seccion.selector) : document.getElementById(seccion.id);
            if (elemento && html[seccion.id]) elemento.innerHTML = drawer.getSectionInnerHTML(html[seccion.id], seccion.selector);
          });

          // El fondo oscuro es nuevo: hay que volver a enseñarle a cerrar.
          drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', drawer.close.bind(drawer));

          const carrito = await fetch(`${window.routes.cart_url}.js`).then((r) => r.json());
          drawer.classList.toggle('is-empty', carrito.item_count === 0);
        } catch (e) {
          // Si no se pudo repintar, el carrito se ve al recargar.
        }
      }

      reset() {
        this.filas.forEach((fila) => {
          this.input(fila).value = 0;
        });
        this.refresh();
      }
    }
  );
}
